/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Writing_Mode_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Toggle writing mode between horizontal and vertical" |
*
* @param {Writing_Mode_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const writing_mode_aria_label = /** @type {((inputs?: Writing_Mode_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Writing_Mode_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer le mode d'ecriture entre horizontal et vertical")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schreibmodus zwischen horizontal und vertikal umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Alterna la modalità di scrittura tra orizzontale e verticale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключать режим письма между горизонтальным и вертикальным")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alternar el modo de escritura entre horizontal y vertical")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换横向和纵向书写模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("横書きと縦書きを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लेखन मोड को क्षैतिज और ऊर्ध्वाधर के बीच टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar o modo de escrita entre horizontal e vertical")
	return /** @type {LocalizedString} */ ("Toggle writing mode between horizontal and vertical")
});